import React, { useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import "./modals-styles.scss"
import SuspendOrArchieveEnum from '../../../constants/clients.constants'
const SubscriptionSuspendModal = ({show,hideModal, onSuspend = () => {}, type}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [reason, setReason] = useState("");

  const handleSuspend = async () => {
    setIsLoading(true);
    const response = await onSuspend(reason);
    setIsLoading(false);
    return response;
  }

  if (!show) return null;
  return (
    <Modal
    show={show}
    dialogClassName=""
    className="modal-height-auto modal-radius-8 "
    aria-labelledby=" "
    centered
    scrollable
    onHide={hideModal}
  >
<Modal.Body className='p-3'>
    <div className='f-16 f-500 mb-3'>Are you sure you want to {type === SuspendOrArchieveEnum.SUSPEND ? "suspend" : "deactivate"} this account?</div>
    <div className='f-14 f-500 mb-3'>Users will be unable to login to their account</div>
    <div className='f-14 f-darkgrey mb-2'>Reason</div>
    <textarea
    rows={8}
    className='w-100 p-2 border-grey radius-4'
    placeholder='Reason'
    value={reason}
    onChange={(e) => setReason(e.target.value)}
    />
</Modal.Body>

<Modal.Footer className='p-2 d-flex align-items-center justify-content-end border-none'>
    <Button 
      className='hg-cancel-btn mr-2'
      onClick={hideModal}
    >
      Cancel
    </Button>
    <Button className='hg-red-btn d-flex align-items-center gap-4' onClick={handleSuspend} disabled={isLoading}>
      {isLoading && (
        <Spinner
          animation="border"
          size="sm"
          style={{
            width: "16px",
            height: "16px",
          }}
        />
      )}
      <span>{type === SuspendOrArchieveEnum.SUSPEND ? "Suspend" : "Deactivate"}</span>
    </Button>

</Modal.Footer>

  </Modal>
  )
}

export default SubscriptionSuspendModal